import { useTranslation } from "react-i18next";
import { CommuneIcon, Calendar, Mayor, Population } from "../../assets";
import { formatNumber } from "../../utils/common";

const DataFact = ({ t, data }) => {
  const { i18n } = useTranslation();
  const language = i18n.language;
  const notAvailable = data.membersCount === "Nicht mitgeteilt";

  const lookup = {
    de: "Nicht mitgeteilt",
    fr: "Non communiqué",
    en: "Not reported",
    pt: "Não comunicado",
  };

  return (
    <div className="px-0 mt-6 w-full">
      <span className="text-22 font-semibold">{t("facts")}</span>
      <div className="grid grid-cols-2 gap-4 mt-2 mb-6">
        <div className="pl-3 pt-2.5 bg-wort-background h-70">
          <div className="flex flex-row items-center">
            <Population className="mr-2 w-[28px] h-[22.6px]" />
            <span className="text-xs">{t("memberNumber")}</span>
          </div>
          <div className="flex flex-row items-baseline">
            <span className="font-semibold text-18 leading-6 mr-2 mt-2 text-secondary md:leading-lw md:text-22">
              {notAvailable
                ? lookup[language]
                : formatNumber(data.membersCount, language)}
            </span>
            <span className=" text-xs">(01.01.2023)</span>
          </div>
        </div>
        <div className="px-3 pt-2 bg-wort-background h-70 ">
          <div className="flex flex-row items-center">
            <Calendar className="mr-2 w-[28px] h-[22.6px]" />
            <span className="text-xs md:text-sm">{t("foundingYear")}</span>
          </div>
          <div className="flex flex-row items-baseline">
            <span className="font-semibold text-18 leading-6 mt-1 text-secondary md:leading-lw md:text-22">
              {data.foundationYear}
            </span>
          </div>
        </div>
        <div className="px-3 pt-2.5 bg-wort-background h-[74px] pb-1">
          <div className="flex flex-row items-center">
            <Mayor className="mr-2 w-[28px] h-[22.6px]" />
            <span className="text-xs md:text-sm">{t("municipalMandates")}</span>
          </div>
          <div className="flex flex-col items-baseline">
            <span className="font-semibold text-18 leading-6 mr-2 mt-2 text-secondary md:leading-lw md:text-22">
              {data.incumbentsInMunicipalities
                ? data.incumbentsInMunicipalities
                : "0"}
            </span>
          </div>
        </div>
        <div className="px-3 pt-2.5 bg-wort-background">
          <div className="flex flex-row items-center">
            <CommuneIcon className="mr-2 w-[28px] h-[22.6px]" />
            <span className="text-xs md:text-sm">{t("deputieNumber")}</span>
          </div>
          <div className="flex flex-row items-baseline">
            <span className="font-semibold leading-6 mr-2 mt-2 text-secondary md:leading-lw md:text-22">
              {data.incumbentDeputies ? data.incumbentDeputies : "0"}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataFact;
